<!-- @format -->

<div class="pinned-content-spot hmf-pt-s hmf-mt-0">
	@if (isStandardPCS()) {
		<a
			class="hmf-padding-0 hmf-text-align-initial hmf-soft-radius hmf-display-block"
			[href]="pinnedContent().cta[0].link"
			[attr.data-em]="row() + '_' + column() + '_' + pinnedContent().headline?.replace(replace, '')"
			[class.no-availability-data-height]="!availabilityOnProductCardsEnabled()"
			(click)="fireBeacon()"
			[attr.title]="pinnedContent().cta[0].linkTitle"
			[attr.aria-label]="pinnedContent().cta[0].linkTitle">
			<ng-container [ngTemplateOutlet]="cardContent"></ng-container>
		</a>
	} @else {
		<button
			class="hmf-padding-0 hmf-text-align-initial hmf-soft-radius"
			[attr.data-em]="row() + '_' + column() + '_' + pinnedContent().headline?.replace(replace, '')"
			[class.no-availability-data-height]="!availabilityOnProductCardsEnabled()"
			(click)="handlePzPinnedContent()"
			[attr.title]="pinnedContent().cta[0].linkTitle"
			[attr.aria-label]="pinnedContent().cta[0].linkTitle">
			<ng-container [ngTemplateOutlet]="cardContent"></ng-container>
		</button>
	}
</div>

<ng-template #cardContent>
	<div
		class="rs_card_layout pinned-content-image-container"
		[ngClass]="[pinnedContent().textColor ? pinnedContent().textColor : 'dark']">
		<span class="pinned-content-intersection-observation-block hmf-display-inline-block hmf-position-absolute"></span>
		<shared-media-component-media
			[altText]="altText()"
			[image]="image()"
			[imagePagePosition]="imagePagePosition()"
			[mobileImg]="mobileImage()"
			[visualAssets]="pinnedContent().visualAssets"
			[willLazyLoad]="lazyLoad()"
			[itemTitle]="
				pinnedContent().headline || pinnedContent().Subhead || pinnedContent().altText
			"></shared-media-component-media>
		<div
			[class]="pinnedContent().textColor + (isPublicLands ? ' pinned-content-text-overlay-pl hmf-px-xs hmf-pb-xs hmf-pt-0' : ' pinned-content-text-overlay')"
			>
			<div
				class="pinned-content-text-headline hmf-m-0 hmf-body-bold-l"
				[ngClass]="{
					'hmf-display-m-xs hmf-pb-xs hmf-pb-m-s hmf-label-s hmf-text-transform-m-uppercase': isPublicLands
						}">
				{{ pinnedContent().headline }}
			</div>
			<div
				class="pinned-content-text-subhead hmf-m-0 hmf-body-s"
				[ngClass]="{ 'hmf-header-bold-m-m hmf-pb-xs hmf-pb-m-s': isPublicLands }">
				{{ pinnedContent().Subhead }}
			</div>
			@if (!isPublicLands) {
				<hmf-button
					class="hmf-m-0 hmf-label-s"
					[class.white]="pinnedContent().textColor === 'light'"
					[class.black]="pinnedContent().textColor !== 'light'"
					variant="tertiary"
					[text]="pinnedContent().cta[0].linkTitle"
					[dataEm]="row() + '_' + column() + '_' + pinnedContent().headline?.replace(replace, '')"
					tabindex="-1"
					aria-hidden="true" />
			} @else {
				<span
					class="hmf-body-m hmf-display-flex hmf-align-items-center hmf-justify-content-center pl-custom-button-colors pl-custom-button-text"
					[attr.data-em]="row() + '_' + column() + '_' + pinnedContent().headline?.replace(replace, '')"
					aria-hidden="true">
					{{ pinnedContent().cta[0].linkTitle }}
				</span>
			}
		</div>
	</div>
</ng-template>

@if (isSponsored()) {
	<div
		class="sponsored hmf-legal-s hmf-pt-xxxs">
		Sponsored
	</div>
}
